import React, {FC} from "react";
import {IconButton, makeStyles} from "@material-ui/core";
import {Link as RouterLink} from "react-router-dom";
import {MoreVert} from "@material-ui/icons";
import {EntityId} from "@reduxjs/toolkit";

const useStyles = makeStyles(() => ({
    workerMoreMenuContainer: {
        display: 'flex',
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center'
    }
}))

export const WorkerMoreMenu: FC<{ id: EntityId }> = ({id}) => {
    const classes = useStyles();
    return (
        <div className={classes.workerMoreMenuContainer}>
            <IconButton
                component={RouterLink}
                to={`/workers/worker/${id}`}
            >
                <MoreVert/>
            </IconButton>
        </div>
    )
}